import store from '@/vuex/store'
import i18n from '@/plugins/i18n'
const locale = store.state.locale
i18n.locale = locale
const menuActionsModel = [
  {
    id: '0',
    to: 'new-dashboard',
    name: i18n.t('message.menuComponent.item0'),
    icon: 'home',
    shortName: i18n.t('message.menuComponent.item0'),
    isMobile: true
  },
  {
    id: '53',
    to: 'search',
    name: i18n.t('message.searchComponent.sections.title'),
    icon: 'person',
    shortName: i18n.t('message.searchComponent.title'),
    isMobile: false
  },
  {
    id: '27',
    to: 'documents',
    name: i18n.t('message.DocumentsComponents.title'),
    icon: 'paper-pen',
    shortName: i18n.t('message.DocumentsComponents.title'),
    isMobile: true
  },
  {
    id: '3',
    to: 'documents-search',
    name: i18n.t('message.DocumentsComponents.searchDocuments'),
    icon: 'paper-pen',
    shortName: i18n.t('message.searchComponent.title'),
    isMobile: false
  },
  {
    id: '72',
    to: 'licenses',
    name: i18n.t('message.menuComponent.licences.name'),
    icon: 'calendar-num',
    shortName: i18n.t('message.menuComponent.licences.shortName'),
    isMobile: true
  },
  {
    id: '71',
    to: 'licensesManager',
    name: i18n.t('message.menuComponent.licences.name'),
    icon: 'calendar-num',
    shortName: i18n.t('message.menuComponent.licences.shortName'),
    isMobile: true
  },
  {
    id: '77',
    to: 'documentsManagement',
    name: i18n.t('message.menuComponent.item5'),
    icon: 'box-up',
    shortName: i18n.t('message.menuComponent.sended'),
    isMobile: true
  },
  {
    id: 'payroll',
    to: 'salaryAdvances',
    name: 'Anticipo',
    icon: 'bank-outlined',
    shortName: 'Anticipo',
    isMobile: true
  },
  {
    id: 'op',
    to: '',
    url: 'https://pas.sichern.com.ar',
    name: i18n.t('message.menuComponent.goToDashboard'),
    icon: 'bank-outlined',
    shortName: i18n.t('message.menuComponent.goToDashboard'),
    isMobile: false
  }
]

const managerActionsModel = [
  {
    id: '0',
    to: 'Dashboard',
    name: 'Dashboard',
    icon: 'dashboard',
    shortName: 'Dashboard',
    isMobile: true
  },
  {
    id: '113',
    to: 'task-manager',
    icon: 'clipboard-task',
    name:  i18n.t('message.menuComponent.tasks'),
    shortName: i18n.t('message.menuComponent.tasksShort'),
    isMobile: true
  },
  {
    id: '53',
    to: 'search',
    name: i18n.t('message.searchComponent.sections.title'),
    icon: 'person',
    shortName: i18n.t('message.searchComponent.title'),
    isMobile: false
  },
  {
    id: '3',
    to: 'documents-search',
    name: i18n.t('message.DocumentsComponents.searchDocuments'),
     icon: 'paper-pen',
    shortName: i18n.t('message.searchComponent.title'),
    isMobile: false
  },
  {
    id: '71',
    to: 'licensesManagerPage',
    name: i18n.t('message.menuComponent.manageAbs'),
    icon: 'calendar-num',
    shortName: i18n.t('message.menuComponent.licences.shortName'),
    isMobile: true
  },
  {
    id: '113',
    to: 'Myteam',
    name: i18n.t('message.myTeam.title'),
    icon: 'my-team-horizontal',
    shortName: i18n.t('message.myTeam.shortName'),
    isMobile: true
  },
  {
    id: 'payroll-manager',
    to: 'requestSalaryAdvances',
    name: 'Adelanto',
    icon: 'bank-outlined',
    shortName: 'Adelanto',
    isMobile: true
  }
]

export { menuActionsModel, managerActionsModel }
